{
    "app": {
        "sidebar": {
            "collapse": "Collapse sidebar",
            "expand": "Expand sidebar"
        },
        "brand": {
            "name": "gaia ecologie"
        },
        "dashboard": {
            "title": "Dashboard",
            "theme": "Switch to {{theme}} theme"
        },
        "errorScreen": {
            "title": "Something went wrong"
        },
        "gaiaFilterOptions": {
            "title": "Filters"
        },
        "gaiaFilterHeader": {
            "drawerTitle": "Filter"
        },
        "gaiaGridOverlay": {
            "noResults": "No results"
        },
        "gaiaConfirmCloseDialog": {
            "title": "Unsaved changes",
            "description": "Form data will be lost. Continue?",
            "cancel": "Cancel",
            "proceed": "Continue"
        },
        "gaiaConfirmDialog": {
            "defaultTitle": "Warning",
            "defaultDescription": "This action cannot be undone. Continue?",
            "cancel": "Cancel",
            "proceed": "Continue"
        },
        "gaiaDialog": {
            "cancel": "Cancel",
            "save": "Save"
        },
        "gaiaColorPicker": {
            "btnPickColor": "Pick Color",
            "btnClose": "Close"
        },
        "workerJobStatus": {
            "working": "Working...",
            "success": "Finished",
            "failed": "Something went wrong"
        },
        "notification": {
            "notifications": "Notifications",
            "noNotifications": "No new notifications available at the moment"
        },
        "dashboardComponents": {
            "mainDashboardScreen": {
                "title": "Welcome {{firstName}}"
            },
            "dashboardFieldworkerOnboarding": {
                "title": "Onboarding",
                "description": "Fill in the following information to get started with work"
            },
            "dashboardFieldworkerAvailabilityRequired": {
                "title": "Welcome {{firstName}}",
                "description": "Fill in your general availability to get started. Additionally, indicate the maximum number of shifts you want to work per week. You can request time off later through your calendar.",
                "btnAvailability": "Fill in your availability now"
            },
            "dashboardFieldworkerNextDays": {
                "title": "Fieldworker insights",
                "description": "Your next {{numberOfDays}} days at a glance",
                "availability": "Availability",
                "updateAvailability": "Update"
            },
            "dashboardFieldworkerNextShift": {
                "nextShift": "Next shift",
                "btnGoToShifts": "Shifts",
                "noUpcomingShift": "No upcoming shift"
            },
            "dashboardFieldworkerLatestFeedback": {
                "latestFeedback": "Latest feedback",
                "btnGoToFeedback": "Feedback",
                "noRecentFeedback": "No recent feedback"
            },
            "dashboardClientUserClientList": {
                "clients": "Clients",
                "allProjectsBtn": "All Projects"
            },
            "dashboardProjectUserProjectList": {
                "projects": "Projects",
                "startDate": "Start date",
                "mapViewBtn": "Open"
            }
        },
        "functionCard": {
            "mediaLabel": "Media"
        }
    },
    "admin": {
        "adminMenu": {
            "headerAdmin": "Admin",
            "itemClients": "Clients",
            "itemUsers": "Users",
            "itemLibrary": "Library",
            "itemPayments": "Payments",
            "itemSettings": "Settings"
        }
    },
    "user": {
        "userCreateScreen": {
            "title": "New user"
        },
        "userUpdateScreen": {
            "fieldworkerTitle": "Fieldworker info",
            "fieldworkerCreate": "Make fieldworker",
            "roleTitle": "Role",
            "researchRequirementsTitle": "Research Requirements",
            "btnViewAvailability": "View availability",
            "btnViewShifts": "View shifts",
            "passwordTitle": "Password",
            "title": "User"
        },
        "userCourseList": {
            "colName": "Name",
            "colIsCompleted": "Completed",
            "colDelete": "Delete"
        },
        "userListScreen": {
            "title": "Users",
            "colName": "Name",
            "colEmail": "Email",
            "colPhone": "Phone",
            "colRole": "Role",
            "colTimeoff": "Timeoff",
            "tooltipNewUser": "Add New User",
            "tooltipImportUsers": "Import Users",
            "filterSearch": "Search",
            "filterCourse": "Course",
            "filterTransportation": "Transportation",
            "filterRole": "Role"
        },
        "userImportScreen": {
            "title": "Users Import"
        },
        "userForm": {
            "labelFirstname": "First name",
            "labelLastname": "Last name",
            "labelPhone": "Phone number",
            "labelPhoneCountry": "Phone country",
            "sectionContact": "Contact info",
            "labelEmail": "E-mail",
            "labelPassword": "Password",
            "labelRole": "Role",
            "sectionFieldworkerDetails": "Fieldworker details",
            "btnSubmit": "Save",
            "btnLogout": "Logout",
            "labelAddress": "Address",
            "labelAddressNoOptions": "Fill in your street and house number",
            "labelHaveACar": "Do you have a car?",
            "sectionPassword": "Password",
            "labelCurrentPassword": "Current password",
            "labelNewPassword": "New password",
            "labelConfirmNewPassword": "Confirm new password",
            "labelExternalReference": "External Reference ID",
            "setPassword": "Set password",
            "language": "Language"
        },
        "userCreateForm": {
            "labelFirstname": "First name",
            "labelLastname": "Last name",
            "sectionContact": "Contact info",
            "labelPhone": "Phone number",
            "labelEmail": "E-mail",
            "labelRole": "Role",
            "sectionPassword": "Create password",
            "labelPassword": "Password",
            "btnSubmit": "Save",
            "sendInvite": "Send Invite",
            "emailInvalid": "Invalid email address",
            "emailRequired": "E-mail is required",
            "errorConfirmPasswordMismatch": "Passwords do not match",
            "labelConfirmPassword": "Confirm password"
        },
        "fieldworkerForm": {
            "title": "Fieldworker",
            "create": "Make fieldworker",
            "labelAddress": "Address",
            "labelAddressNoOptions": "Fill in your street and house number",
            "labelHasOwnTransport": "Has transport",
            "labelIsMywheelsUser": "Mywheels User",
            "labelHasFinishedOnboarding": "Finished Onboarding",
            "hasConfirmedAvailability": "Confirmed Availability",
            "labelIsPayable": "Payable",
            "labelIsActive": "Active worker",
            "labelAdmin": "Admin",
            "btnSubmit": "Save"
        },
        "fieldworkerOnboardingForm": {
            "labelAddress": "Address",
            "labelHaveACar": "Do you have a car?",
            "labelHasADriversLicense": "Do you have a Drivers License?",
            "label21yearsOrOlder": "Are you 21 years or older?",
            "labelAddressNoOptions": "Fill in your street and house number",
            "labelHasDriversLicenseMoreThan1Year": "Do you have a Drivers License for more than 1 year?",
            "btnSubmit": "Save"
        },
        "fieldWorkerCreateAccount": {
            "applyForFieldWorker": "Apply for fieldwork",
            "createFieldWorkerAccount": "Create a fieldworker account to get started",
            "firstNameLabel": "Firstname",
            "surnameLabel": "Surname",
            "emailLabel": "Email",
            "phoneNumberLabel": "Phone number",
            "passwordLabel": "Password",
            "submitButtonLabel": "Start now",
            "consentText": "I agree to the <1>Terms of Service</1> and <2>Privacy Policy</2>.",
            "errors": {
                "firstNameRequired": "First name is required",
                "surnameRequired": "Surname is required",
                "emailRequired": "Email is required",
                "emailInvalid": "Invalid email address",
                "phoneRequired": "Phone number is required",
                "passwordRequired": "Password is required",
                "passwordMinLength": "Password must be at least 8 characters",
                "consentRequired": "You must agree to the terms to proceed."
            }
        },
        "profilePhotoUploader": {
            "title": "Select profile picture",
            "labelChangePhoto": "Change photo",
            "labelUploadPhoto": "Upload photo",
            "labelAllowedFormats": "Allowed formats: JPG, PNG (Max size: 5MB)"
        },
        "userImportFeedback": {
            "users": "Users",
            "title": "Import Users",
            "newFieldworkers": "New Fieldworkers {{newFieldworkers}} users.",
            "imported": "Imported {{success}} / {{total}} users.",
            "couldNotImport": "{{usersNotImported}} Users could not be imported."
        }
    },
    "auth": {
        "login": {
            "btnNewClient": "New Client",
            "btnStartProject": "Start project",
            "btnNewWorker": "New Fieldworker",
            "btnApplyNow": "Apply now"
        },
        "loginForm": {
            "title": "Login",
            "emailLabel": "E-mail",
            "passwordLabel": "Password",
            "btnLogin": "Log in",
            "btnForgotPassword": "Forgot password?",
            "errorUsernameOrPassword": "Invalid username or password"
        },
        "resetPasswordScreen": {
            "title": "Reset password"
        },
        "createPasswordScreen": {
            "title": "Create password",
            "description": "Please enter new password for your account",
            "btnCreatePassword": "Create password"
        },
        "resetPasswordForm": {
            "labelEmail": "E-mail",
            "labelNewPassword": "New password",
            "labelNewPasswordRequired": "New password is required",
            "helperTextNewPassword": "Minimum 8 characters, at least 1 number and 1 special character (@, #, $, %, &, !)",
            "labelConfirmNewPassword": "Confirm new password",
            "labelConfirmNewPasswordRequired": "Confirm new password is required",
            "labelEmailRequired": "E-mail is required",
            "btnSubmit": "Submit",
            "btnBack": "Back",
            "success": "A password reset link has been sent to your email address: {{email}}",
            "resetPassword": "Reset password"
        }
    },
    "client": {
        "clientMenu": {
            "itemDashboard": "Dashboard",
            "projects": "Projects",
            "planned": "Planning",
            "invoices": "Invoices",
            "protocolTemplates": "Protocol templates",
            "users": "Users",
            "backToClients": "Back to clients",
            "settings": "Settings",
            "projectExport": "Exports"
        },
        "clientListScreen": {
            "title": "Clients",
            "colName": "Name",
            "colType": "Type",
            "filterName": "Name"
        },
        "clientCreateScreen": {
            "title": "New client",
            "btnSubmit": "Create"
        },
        "clientUpdateScreen": {
            "title": "Edit client",
            "btnSubmit": "Update"
        },
        "clientForm": {
            "name": "Name",
            "type": "Type",
            "typeValue": {
                "Private": "Private",
                "Organisation": "Organisation"
            },
            "address": "Address",
            "sectionContact": "Contact info",
            "contactName": "Contactpersoon",
            "contactEmail": "E-mail",
            "contactPhone": "Phone number",
            "allLayersVisible": "All new layers visible"
        }
    },
    "invoice": {
        "list": {
            "title": "Invoice periods",
            "table": {
                "year": "Year",
                "month": "Month",
                "createdAt": "Created",
                "amount": "Amount",
                "numberOfRecords": "Number of visits",
                "actions": {
                    "view": "Open",
                    "create": "Create"
                }
            }
        },
        "detail": {
            "emptyPage": "No invoice information available",
            "invoiceForPeriod": "Invoice for {{period}}",
            "totalCostPeriod": "Total amount for period",
            "project": "Project",
            "amount": "Amount",
            "btnDownloadCsv": "Download CSV",
            "visit": {
                "completedVisits": "Completed visits",
                "date": "Date",
                "protocolName": "Protocol",
                "visitNumber": "#",
                "travelTime": "Travel time",
                "travelDistance": "Distance (round trip)",
                "travelCostPerKm": "Cost/ km (round trip)",
                "requiredFieldworkers": "Workers",
                "pricePerHour": "Rate/h",
                "duration": "Time",
                "cost": "Total"
            },
            "title": "Invoice"
        }
    },
    "project": {
        "projectMenu": {
            "itemDashboard": "Dashboard",
            "users": "Project users",
            "planning": "Planning",
            "projectExport": "Export",
            "deliverables": "Deliverables",
            "protocols": "Protocols",
            "overview": "Overview",
            "mapView": "Map view",
            "settings": "Settings",
            "cost": "Cost"
        },
        "projectListScreen": {
            "title": "Projects",
            "colName": "Name",
            "filterName": "Name",
            "colStatus": "Status",
            "projectStatusValue": {
                "open": "Open",
                "confirmed": "Confirmed",
                "cancelled": "Cancelled",
                "completed": "Completed"
            }
        },
        "ProjectStatusSelect": {
            "labelStatus": "Status",
            "projectStatusValue": {
                "open": "Open",
                "confirmed": "Confirmed",
                "cancelled": "Cancelled",
                "completed": "Completed"
            }
        },
        "projectCreateScreen": {
            "title": "New project",
            "btnSubmit": "Create"
        },
        "projectUpdateScreen": {
            "title": "Edit project",
            "btnSubmit": "Update",
            "btnDelete": "Delete Project",
            "dangertitle": "Danger zone"
        },
        "projectForm": {
            "labelName": "Name",
            "sectionContact": "Contact info",
            "labelContactName": "Contactpersoon",
            "labelContactEmail": "E-mail",
            "labelContactPhone": "Phone number",
            "sectionStatus": "Status info",
            "labelProjectStatus": "Project status",
            "labelIsSpeciesManagementPlan": "Species management plan",
            "labelShowAllObservationsToClientUser": "Show all observations to client",
            "projectStatusValue": {
                "open": "Open",
                "confirmed": "Confirmed",
                "cancelled": "Cancelled",
                "completed": "Completed"
            },
            "labelStartDate": "Start date",
            "sectionFinancials": "Financials",
            "labelTravelAllowanceKms": "Travel distance (round trip, km)",
            "labelTravelAllowancePerKmCents": "Travel allowance per km (cents EUR)",
            "labelTravelAllowanceTimeInSeconds": "Travel time (round trip)",
            "selectTravelAllowanceTimeInSeconds": {
                "30-minutes": "30 minutes",
                "45-minutes": "45 minutes",
                "1-hour": "1 hour",
                "1.5-hours": "1.5 hours",
                "2-hours": "2 hours",
                "2.5-hours": "2.5 hours",
                "3-hours": "3 hours"
            },
            "validationMinimum0": "This value should be at least 0"
        },
        "projectVisitScreen": {
            "warningIncompleteObservationsTitle": "Report contains incomplete observations",
            "warningIncompleteObservationsDescription": "Incomplete observations are not valid for the results and will be skipped. Do you want to continue?",
            "labelNoSubmittedReports": "No reports have been submitted by the field workers yet.",
            "labelNoPlannedShifts": "No Shift is Planned yet.",
            "visitNumber": "{{protocolName}}, Visit: {{visitNumber}}",
            "btnContinueAndApproveAll": "Continue and approve all pending",
            "btnContinue": "Continue",
            "btnRejectAll": "Cancel and re-plan",
            "labelApproveAllTitle": "Approve all {{items}}",
            "labelApproveAllDescription": "Are you sure you want to Approve all {{items}} and proceed to the next step?",
            "summarySection": {
                "visitConditions": "Weather",
                "summary": "Summary",
                "generateSummary": "Generate summary",
                "confirmGenerateSummaryTitle": "Generate summary again",
                "confirmGenerateSummaryDescription": "Are you sure you want to regenerate the summary? The existing text will be overwritten.",
                "significantObservations": "Conclusions",
                "restObservations": "Observations",
                "observationTable": {
                    "species": "Species",
                    "where": "Where",
                    "address": "Address",
                    "stayPlace": "Stay place"
                },
                "saveSummaryText": "Save summary & approve visit"
            }
        },
        "overviewScreen": {
            "title": "Project Overview",
            "emptyStatistic": "No data available",
            "visitProgress": {
                "title": "Visit Progress",
                "subtitle": "{{completed}} of {{total}} visits"
            },
            "activeProtocols": {
                "title": "Active Protocols",
                "subtitle": "{{active}} / {{total}} protocols active"
            },
            "areas": {
                "title": "Areas",
                "subtitle": "Research locations"
            },
            "functionsFound": {
                "title": "Functions Found",
                "subtitle": "{{recent}} new functions"
            },
            "reports": {
                "title": "Reports",
                "subtitle": "Approved Visits"
            },
            "visitStatusDistribution": {
                "title": "Visit Status Overview",
                "noData": "No visits found",
                "status": "Status",
                "count": "Count",
                "percentage": "Percentage",
                "statusValue": {
                    "approved": "Approved",
                    "ecoTeamReview": "Eco Team Review",
                    "planned": "Planned",
                    "unplanned": "Unplanned"
                },
                "link": "All visits"
            },
            "activeProtocolOverview": {
                "title": "Active Protocol Overview",
                "noData": "No active protocols found",
                "stats": {
                    "numberOfAreas_one": "{{count}} area",
                    "numberOfAreas_other": "{{count}} areas",
                    "numberOfPlannedVisits_one": "{{count}} visit",
                    "numberOfPlannedVisits_other": "{{count}} visits",
                    "numberOfCompletedVisits_one": "{{count}} visit completed",
                    "numberOfCompletedVisits_other": "{{count}} visits completed"
                },
                "link": "All protocols"
            },
            "upcomingVisits": {
                "title": "Upcoming Planned Visits",
                "link": "Planned visits"
            },
            "recentVisits": {
                "title": "Recently Approved Visits",
                "link": "Approved visits"
            }
        },
        "deliverablesScreen": {
            "labelResearchType": "Research Type",
            "labelPlannerAreas": "Planner Areas",
            "copyBtn": "Copy",
            "noData": "No data found",
            "map": {
                "legend": {
                    "title": "Legend",
                    "species": "Species",
                    "functions": "Functions",
                    "areas": "Areas",
                    "plannerArea": "Planner area"
                }
            }
        },
        "projectVisitInfo": {
            "title": "Visit",
            "labelVisitNumber": "Visit Number: {{visitNumber}}",
            "labelStartAt": "Start: {{startAt}}",
            "labelEndAt": "End: {{endAt}}",
            "labelPlannedDuration": "Planned Duration: {{plannedDuration}}",
            "btnOpenPlanner": "Open in planner",
            "requiredWorkers": "Required workers"
        },
        "projectVisitStatusControl": {
            "title": "Status",
            "visitStatus": {
                "unplanned": "Unplanned",
                "undrafted": "Undrafted",
                "draft": "Draft",
                "planned": "Planned",
                "awaitingReports": "Awaiting reports",
                "awaitingApproval": "Awaiting approval",
                "approved": "Approved",
                "rejected": "Rejected"
            }
        },
        "projectVisitReportStatus": {
            "labelReports": "{{handledReports}}/{{totalReports}} Reports",
            "visitStatus": {
                "unplanned": "Unplanned",
                "draft": "Draft",
                "planned": "Planned",
                "awaitingReports": "Awaiting reports",
                "awaitingApproval": "Awaiting approval",
                "approved": "Approved",
                "rejected": "Rejected"
            }
        },
        "generateReportSummaryButton": {
            "btnGenerateReportSummary": "Generate Report Summary"
        },
        "projectVisitWorkerReport": {
            "labelStartedAt": "Started at",
            "labelStoppedAt": "Stopped at",
            "labelDayReport": "Day Report",
            "labelAwaitingReport": "Awaiting worker report submission.",
            "visitNumber": "Visit {{visitNumber}}",
            "btnSave": "Save",
            "titleStartForm": "Start form",
            "titleNotes": "Notes",
            "noNotes": "No notes added.",
            "titleSubmittedForm": "End form",
            "report": "Report",
            "precipitation": "Precipitation",
            "temp": "Temperature (°C)",
            "cloudiness": "Cloudiness %",
            "wind": "Wind (bft)",
            "wind-direction": "Wind direction",
            "btnClose": "Close",
            "labelDuration": "Total Duration: {{duration}}",
            "labelIsOutOfProtocol": "Out of protocol",
            "labelOutOfProtocolNotes": "Out of protocol Notes",
            "labelStartStopLong": "{{date}} from {{startTime}} to {{endTime}} ({{duration}})",
            "rateReport": "Rate the report",
            "createEmptyReport": "Create empty report"
        },
        "readyForPaymentForm": {
            "labelReadyForPayment": "Ready for payment"
        },
        "projectVisitShiftReport": {
            "labelStartAt": "Start: {{startAt}}",
            "labelEndAt": "End: {{endAt}}",
            "labelShiftId": "Shift ID: {{shiftId}}"
        },
        "deviationFromProtocol": {
            "title": "Deviated from protocol",
            "btnSave": "Save",
            "labelDeviatedFromProtocolNotes": "Deviation Notes",
            "labelDeviatedFromProtocolWarning": "Please provide notes for deviation"
        },
        "projectVisitFullReport": {
            "labelSummary": "Summary",
            "labelEditSummary": "Edit Summary",
            "labelSummaryNotYetAvailable": "Summary is not yet available.",
            "btnGenerateReportSummary": "Generate Report Summary",
            "btnEdit": "Edit",
            "btnSave": "Save",
            "btnCancel": "Cancel"
        },
        "observationMediaDisplay": {
            "labelMedia": "Media"
        },
        "observationPanel": {
            "labelObservations": "Observations"
        },
        "visitStatusActionButton": {
            "labelApprove": "Approve",
            "labelReject": "Reject",
            "labelRevertApproval": "Revert Approval"
        },
        "visitList": {
            "noVisitName": "Visit",
            "observations": "Observations",
            "conclusions": "Results",
            "noObservations": "No observations",
            "noConclusions": "No results",
            "linkedObservations": "Linked observations",
            "animalsCount": "Total animals"
        },
        "feedbackForm": {
            "title": "Feedback on report",
            "feedbackRating": "Feedback",
            "feedbackComment": "Comment"
        },
        "projectReviewVisitV2": {
            "backToOverviewBtn": "Back to all visits",
            "visitInfoCard": {
                "requiredWorkers": "Required Workers",
                "plannedDuration": "Planned Duration",
                "start": "Min. Start time",
                "end": "Max. End time",
                "sunriseTime": "Sunrise Time",
                "sunsetTime": "Sunset Time",
                "btnOpenPlanner": "Open in Planner"
            },
            "overview": {
                "hasStagedChanges": "This visit has pending changes in the planner.",
                "navigationItems": {
                    "time": {
                        "label": "Time",
                        "caption": "All reports were automatically validated"
                    },
                    "weather": {
                        "label": "Weather",
                        "caption": "All reports were automatically validated"
                    },
                    "teamReports": {
                        "label": "Team Reports",
                        "caption": "Needs review"
                    },
                    "functions": {
                        "label": "Functions",
                        "caption": "No items to review"
                    },
                    "observations": {
                        "label": "Observations",
                        "caption": "No items to review"
                    }
                },
                "finalisePending": "Please finalise the items above.",
                "finaliseButton": "Finalise the report",
                "approveDialog": {
                    "title": "Are you sure you want to approve this visit?",
                    "description": "This action cannot be undone. The visit results will be visible to the client."
                }
            },
            "approvalAlert": {
                "approvedBy": "This visit was approved by",
                "on": "on {{date}}.",
                "openFinalReport": "Open final report"
            },
            "rejectionAlert": {
                "rejectedBy": "This visit was rejected by",
                "on": "on {{date}}.",
                "reasonLabel": "Reason for rejection",
                "revertButton": "Revert rejection",
                "revertDialog": {
                    "title": "Revert rejection?",
                    "message": "Are you sure you want to revert the rejection? The visit will return to awaiting approval status.",
                    "cancel": "Cancel",
                    "confirm": "Revert rejection"
                }
            },
            "status": {
                "unplanned": {
                    "title": "This visit is not planned yet."
                },
                "planned": {
                    "title": "This visit is planned.",
                    "scheduledFor": "This visit is planned for {{date}}."
                },
                "awaitingReport": {
                    "title": "This visit is awaiting report.",
                    "description": "This visit took place on {{date}}. Some data is still missing or pending submission.",
                    "fieldworkersWithoutReportsLabel": "We are waiting for reports from:"
                },
                "openInPlannerButton": "Open in Planner"
            },
            "functionsRoute": {
                "title": "Functions",
                "functionDetailTitle": "Function",
                "possibleFunctionObservationDetailTitle": "Possible function",
                "noFunctions": "No functions",
                "possibleFunctionsTab": "Possible functions ({{ value }})",
                "createdFunctionsTab": "Created functions ({{ value }})"
            },
            "observationsRoute": {
                "title": "Observations",
                "observationDetailTitle": "Review observation",
                "bulkApproveDialog": {
                    "title": "Approve All Observations",
                    "description": "Are you sure you want to approve all valid observations?"
                },
                "bulkApproveButton": "Approve all valid observations",
                "bulkApproveButtonLoading": "Approving...",
                "noObservations": "No observations found"
            },
            "teamReportsRoute": {
                "title": "Team Reports",
                "errorMsg": "Team reports can't be approved until visit start and end times are confirmed, as fieldworker pay is calculated from those times.",
                "labelNoReportsFound": "No reports found.",
                "workerReport": {
                    "labelRateReport": "Rate the report",
                    "labelFeedbackComment": "Comment",
                    "btnSave": "Save",
                    "labelNotes": "Notes",
                    "notSubmitted": "Report not submitted yet",
                    "labelShiftWillBePaid": "Shift will be paid"
                },
                "approvalButton": {
                    "labelApprove": "Approve",
                    "labelRevertApproval": "Revert approval"
                }
            },
            "timeReportsRoute": {
                "title": "Time Reports",
                "requiredWorkers": "Required Workers",
                "start": "Min. Start time",
                "end": "Max. End time",
                "plannedDuration": "Planned Duration",
                "noReportsFound": "No time reports found.",
                "table": {
                    "fieldworker": "Fieldworker",
                    "start": "Start",
                    "end": "End",
                    "duration": "Duration",
                    "saveBtn": "Save"
                }
            },
            "weatherReportsRoute": {
                "title": "Weather Report",
                "temperatureRange": "Temperature Range",
                "maxWindforce": "Max. Windforce",
                "maxPrecipitation": "Max. Precipitation",
                "precipitationLevels": {
                    "dry": "Dry",
                    "mist": "Mist",
                    "drizzle": "Drizzle",
                    "rain": "Rain",
                    "heavyrain": "Heavy Rain",
                    "hail": "Hail",
                    "snow": "Snow"
                },
                "noReportFound": "No weather report found.",
                "table": {
                    "conditions": "Conditions",
                    "start": "Start",
                    "end": "End"
                },
                "metrics": {
                    "temperature": "Temperature",
                    "wind": "Wind",
                    "windForce": "Wind Force",
                    "windDirection": "Wind Direction",
                    "precipitation": "Precipitation",
                    "cloudiness": "Cloudiness"
                }
            },
            "finalReportRoute": {
                "finalReportVisitCard": {
                    "visitNumber": "Visit number"
                },
                "finalReportSummaryCard": {
                    "title": "Summary",
                    "notAvailable": "No summary yet. It is generated once the visit is approved.",
                    "beingGenerated": "The summary is being generated...",
                    "regenerate": "Regenerate summary",
                    "notUpdated": "The summary was not updated. A summary is only made for an approved visit with a visit summary template."
                },
                "finalReportFunctionsCard": {
                    "title": "Functions",
                    "noFunctions": "There are no functions to show."
                },
                "finalReportWeatherCard": {
                    "weatherCardTitle": "Weather Report"
                },
                "finalReportWeatherCardTableHeader": {
                    "conditions": "Conditions",
                    "startForm": "Start form",
                    "endForm": "End form"
                },
                "finalReportWeatherCardTableRow": {
                    "metrics": {
                        "temperature": "Temperature (°C)",
                        "wind": "Wind",
                        "windForce": "Wind Force (Bft)",
                        "windDirection": "Wind Direction",
                        "precipitation": "Precipitation",
                        "cloudiness": "Cloudiness %"
                    }
                },
                "finalReportObservationsCard": {
                    "title": "Observations",
                    "noObservations": "There are no Observations to show"
                },
                "finalReportObservationTable": {
                    "labelType": "Type",
                    "labelWhere": "Where",
                    "labelAddress": "Address"
                }
            },
            "rejectButton": {
                "rejectAndReplan": "Reject and replan the entire visit",
                "rejectedOn": "Rejected on: {{date}}",
                "dialog": {
                    "title": "Reject visit?",
                    "warningMessage": "Are you sure you want to reject this visit? All reports will be rejected, shifts will be cancelled and the visit will be available to be planned in again.",
                    "reasonLabel": "Reason for rejection",
                    "reasonRequired": "Rejection reason is required",
                    "cancel": "Cancel",
                    "confirm": "Confirm rejection"
                }
            },
            "errors": {
                "validationCheckFailed": "Failed to check validation status. Please try again."
            },
            "overrideAutoValidation": {
                "reasonForApproval": "Reason for approval",
                "revertApprovalBtn": "Revert approval",
                "approveBtn": "Approve"
            }
        }
    },
    "projectExport": {
        "ProjectExportListScreen": {
            "title": "Exporteren",
            "createdBy": "Created by",
            "createdAt": "Created at",
            "researchTypes": "Research Types",
            "projectIds": "Projects",
            "template": "Exported files",
            "status": "Status",
            "createButton": "New export",
            "deleteDialog": {
                "title": "Delete export",
                "description": "This action cannot be undone. Proceed?"
            }
        },
        "ProjectExportCreateForm": {
            "title": "New export",
            "researchTypes": "Research Types",
            "projectIds": "Projects",
            "selectAll": "Select all",
            "template": "Exported files",
            "mediaIncluded": "Include media files",
            "createButton": "Create",
            "disabledResearchTypeSelectionHelper": "Select one or more projects"
        },
        "ProjectExportCreateScreen": {
            "title": "New export"
        },
        "ProjectExportTable": {
            "delete": "Delete"
        },
        "ExportStatus": {
            "dataFiles": "Data files",
            "mediaFiles": "Media files"
        }
    },
    "planner": {
        "plannerMenu": {
            "header": "Fieldwork planning",
            "itemPlanner": "Planner",
            "itemPlanned": "Planned",
            "itemDevTools": "Dev tools"
        },
        "plannerAreaForm": {
            "title": "Area",
            "titleProtocolArea": "Protocol",
            "labelName": "Name",
            "labelProtocols": "Protocols",
            "labelDescriptionClient": "Description for Client",
            "labelDescriptionFieldworker": "Description for Fieldworker",
            "labelDescriptionInternal": "Internal Notes",
            "btnSave": "Save"
        },
        "plannerAreaProtocolForm": {
            "title": "Add Protocol",
            "btnAddProtocol": "Add protocol",
            "btnSubmit": "Save Protocol"
        },
        "plannerAreaMedias": {
            "title": "Media",
            "btnAddMedia": "Add media"
        },
        "plannerMediaDisplay": {
            "labelUnknownFile": "Unknown File"
        },
        "plannerMediaPreviewDialog": {
            "labelMediaPreview": "Media Preview",
            "btnDownload": "Download",
            "btnDelete": "Delete",
            "btnClose": "Close",
            "notUploaded": "This file has not been uploaded yet"
        },
        "plannerAreaEditor": {
            "tabAreas": "Info",
            "tabVisitList": "Visits",
            "tabSettings": "Settings"
        },
        "areaVisitList": {
            "plannable": "Plannable on {{date}}",
            "outOfProtocol": "Out of protocol",
            "overdue": "Overdue",
            "planned": "Planned"
        },
        "visitInfo": {
            "workerInfo": "Workers: {{plannedWorkers}}/{{requiredWorkers}}",
            "visitNumber": "Visit {{visitNumber}}",
            "labelTimeslot": "Timeslot",
            "infoTimeslotNotAllowed": "Cancel all shifts to edit date or timeslot.",
            "timeInfo": "Visit start at: {{start}} until {{end}} (excl travel)",
            "visitCombinationPossible": "Shift can be combined with:",
            "visitStartsEarlier": "starts {{minutes}} minutes earlier",
            "visitStartsLater": "starts {{minutes}} minutes later",
            "buttonCombine": "Combine"
        },
        "visitListScreen": {
            "title": "Scheduled visits",
            "areaName": "Area name",
            "visitName": "Visit",
            "protocol": "Protocol",
            "startTime": "Start time",
            "status": "Status",
            "requiredWorkers": "Required workers"
        },
        "plannerVisitList": {
            "noPossibleVisitsOnThisDay": "No visits availabe on this day",
            "planVisits": "Plan all visits",
            "planVisit": "Plan visit",
            "availableDaysLeft": "{{count}} days remaining",
            "noAvailableDaysLeft": "{{count}} days overdue",
            "notYetPlanable": "Not yet plannable",
            "checkVisitManually": "No days available",
            "between": "Between"
        }
    },
    "plannerV2": {
        "fieldworkerAssignments": {
            "labelNeedsFieldworkers_one": "This visit needs {{count}} fieldworker.",
            "labelNeedsFieldworkers_other": "This visit needs {{count}} fieldworkers.",
            "labelNeedsMoreFieldworkers_one": "This visit needs {{count}} more fieldworker.",
            "labelNeedsMoreFieldworkers_other": "This visit needs {{count}} more fieldworkers.",
            "labelHasEnoughFieldworkers": "This visit has enough fieldworkers.",
            "labelHasMoreThanRequired_one": "This visit has {{count}} fieldworker more than required.",
            "labelHasMoreThanRequired_other": "This visit has {{count}} fieldworkers more than required."
        },
        "areaListMapPanel": {
            "areas_one": "{{count}} area",
            "areas_other": "{{count}} areas",
            "noAreasFound": "No areas found.",
            "areasNotShown": "{{count}} areas not shown. Zoom in on the map or use the filters to narrow down the list."
        },
        "areaLists": {
            "atRisk": "At Risk",
            "plannable": "Plannable",
            "plannableSoon": "Plannable soon",
            "planned": "Planned"
        },
        "mapDatepicker": {
            "previousDay": "Previous day",
            "nextDay": "Next day",
            "openCalendar": "Open calendar"
        },
        "plannerStatus": {
            "impossible": "Impossible",
            "notYetPlannable": "Not yet Plannable",
            "planned": "Planned",
            "plannableOk": "Plannable",
            "plannableSoon": "Plannable soon",
            "warning": "Warning",
            "plannableAtRisk": "Plannable at Risk",
            "outOfProtocol": "Out of Protocol"
        },
        "visitStatusTimeline": {
            "impossible": "This visit is impossible to plan. The protocol is not configured properly.",
            "notYetPlannable": "This visit is not yet plannable. It will be available to plan on <bold>{{formattedFirstStartDate}}</bold>.",
            "outOfProtocol": "This visit is out of protocol. The last available date was <bold>{{formattedLatestEndDate}}</bold>.",
            "plannableAtRisk": "This visit is at risk. Plan before <bold>{{formattedLatestEndDate}}</bold> to stay within protocol.",
            "plannableOk": "This visit is plannable. Plan before <bold>{{formattedLatestEndDate}}</bold> to stay within protocol.",
            "plannableSoon": "This visit is plannable soon. Plan before <bold>{{formattedLatestEndDate}}</bold> to stay within protocol.",
            "planned": "This visit is planned."
        },
        "addToVisitButton": {
            "addToVisit": "Add to visit",
            "addToCarpool": "Add to carpool",
            "withPerson": "With {{personName}}",
            "asBiker": "As cyclist ({{distanceInKm}}km,{{durationInMinutes}})"
        },
        "visitDetail": {
            "timeslot": "Timeslot",
            "addFieldworkerInstruction": "Add a fieldworker from the map to plan them into this visit.",
            "visitNumber": "Visit {{visitNumber}}",
            "carpool": "Carpool",
            "driver": "Driver",
            "removeFieldworker": "Remove {{name}}",
            "longBikeRideWarning": "This bike ride is longer than {{minutes}} minutes.",
            "distanceExplanation": "Distance {{travelMethod}}",
            "travelMethod": {
                "bike": "by bike",
                "privateCar": "by car",
                "myWheels": "by MyWheels car",
                "pickup": "by car (passenger)"
            },
            "openInReviewTool": "Open in Review Tool"
        },
        "visitPlannedOnDates": {
            "plannedOn": "Planned on {{date}} ({{carpools}} carpool(s))",
            "cancelledOn": "Cancelled on {{date}} ({{carpools}} carpool(s))",
            "replanOn": "Replan on {{date}}"
        },
        "cancelCarpool": {
            "title": "Cancel carpool?",
            "description": "Canceling this carpool will also cancel the shifts for the passengers."
        },
        "reviewPlanPanel": {
            "visitsDrafted_one": "{{count}} visit drafted",
            "visitsDrafted_other": "{{count}} visits drafted",
            "reviewAndPlanButton": "Review & Plan",
            "reviewAndPlan": "Review & Plan",
            "toBeCancelled": "Visits to be cancelled",
            "toBePlanned": "Visits to be planned",
            "successTitle": "Congrats! 🥳",
            "successMessage": "You have confirmed the planning and notified the relevant fieldworkers.",
            "keepPlanning": "Keep on planning",
            "noVisitsDrafted": "No visits drafted.",
            "selectAll": "Select all",
            "confirmSelected": "Confirm ({{selectedCount}})",
            "cancelSelected": "Cancel ({{selectedCount}})",
            "notificationHint": "When confirming, clients and fieldworkers are notified.",
            "confirmDialogTitle": "Confirm Planning",
            "confirmDialogDescription_one": "Are you sure you want to confirm {{count}} selected change? All relevant fieldworkers will be notified.",
            "confirmDialogDescription_other": "Are you sure you want to confirm {{count}} selected changes? All relevant fieldworkers will be notified.",
            "cancelDialogTitle": "Clear Changes",
            "cancelDialogDescription_one": "Are you sure you want to clear {{count}} selected change? This reverts it to the previously published schedule.",
            "cancelDialogDescription_other": "Are you sure you want to clear {{count}} selected changes? This reverts them to the previously published schedule.",
            "reviewMoreVisits_one": "Review {{count}} more draft visit",
            "reviewMoreVisits_other": "Review {{count}} more draft visits",
            "unknownUser": "Unknown",
            "userCount": "{{selected}}/{{total}}",
            "currentUserSuffix": "me",
            "searchPlaceholder": "Search client, project, area or fieldworker",
            "noSearchResults": "No results match your search"
        },
        "routeDetail": {
            "route": "Route",
            "distance": "distance",
            "duration": "travel duration",
            "time": "time",
            "driver": "Driver"
        },
        "routeActivity": {
            "departs": "{{name}} departs",
            "isPickedUp": "{{name}} is picked up",
            "isDroppedOff": "{{name}} is dropped off",
            "arrives": "{{name}} arrives"
        },
        "travelMethod": {
            "privateCar": "Private Car",
            "myWheels": "MyWheels",
            "bike": "Bike"
        },
        "passengerHomeAddressMarkers": {
            "home": "{{names}}'s Home"
        },
        "gaiaExpandableMapMarkerArea": {
            "addVisitForCarpool": "Add visit carpool",
            "splittingCarpoolInto": "Splitting carpool into visit:",
            "back": "Back"
        },
        "gaiaExpandableMapMarkerFieldworker": {
            "maxShiftsPerWeek": "Max. shifts per week"
        },
        "areaFilters": {
            "title": "Filter Areas",
            "clientFilter": "Client",
            "projectFilter": "Project",
            "plannerAreaFilter": "Area",
            "fieldworkerFilter": "Planner Fieldworker",
            "researchTypeFilter": "Research Type"
        },
        "visitFilters": {
            "title": "Filter Fieldworkers",
            "fieldworkerFilter": "Name",
            "includeUnavailableFilter": "Include Unavailable Fieldworkers"
        },
        "maxRequiredFieldworkersFilter": {
            "label": "Max required amount of fieldworkers",
            "sliderAriaLabel": "Max required amount of fieldworkers"
        }
    },
    "observation": {
        "observationStatus": {
            "approved": "Approved",
            "rejected": "Rejected",
            "awaitingApproval": "Awaiting approval",
            "deleted": "Deleted",
            "incomplete": "Incomplete"
        },
        "observationForm": {
            "labelType": "Type",
            "labelSpecies": "Species",
            "selectItem": "-- Select --",
            "labelCreatedAt": "Created at {{createdAt}}",
            "btnSave": "Save",
            "rateObservation": "Rate the observation",
            "labelDetails": "Details"
        },
        "observationMedias": {
            "title": "Observation medias"
        },
        "observationLink": {
            "link": "Link"
        },
        "observationSubmitButton": {
            "reject": "Reject",
            "approve": "Approve",
            "save": "Save"
        },
        "observationPreciseLocationForm": {
            "title": "Precise Location",
            "labelNotSpecified": "Not specified",
            "btnAddPreciseLocation": "Add Precise Location",
            "btnClose": "Close",
            "address": "Address: ",
            "where": "Where: ",
            "component_roof": "Roof: ",
            "component_wall": "Wall: ",
            "component_terrain": "Terrain: ",
            "other": "Other: ",
            "side": "Side: ",
            "btnSave": "Save"
        },
        "observationApprovalDialog": {
            "title": "Link conclusion",
            "cancel": "Cancel",
            "createConclusion": " Create new conclusion",
            "existingConclusion": "Select conclusion from map",
            "createConclusionManually": "(Create conclusion feature manually and link again)"
        },
        "linkedObservations": {
            "conclusion": "Conclusion observation",
            "observations": "Linked observations"
        }
    },
    "payments": {
        "paymentListScreen": {
            "title": "Payments",
            "labelNoPayment": "No payment has been made",
            "labelNoShiftsToPay": "No unpaid shifts available. payment was not created."
        },
        "paymentRecordAllUser": {
            "title": "Unpaid payments",
            "colName": "Name",
            "colAmount": "Amount",
            "colTotal": "Total",
            "totalUnpaid": "Total unpaid",
            "btnMakeTentooPayment": "Make Tentoo payment",
            "btnMakeOtherPayment": "Make non-Tentoo payment"
        },
        "paidPayments": {
            "title": "Payments",
            "colName": "Name",
            "colCreatedAt": "Created at",
            "colPeriod": "Period",
            "colScope": "Scope",
            "colDay": "Day",
            "colNight": "Night",
            "colDistance": "Distance",
            "totalPaid": "Total paid",
            "btnDownload": "Download"
        },
        "paymentRecordTable": {
            "colAmount": "Amount",
            "colDescription": "Description",
            "colPrice": "Price",
            "colTotal": "Total",
            "colDelete": "Delete",
            "totalAmount": "Total amount"
        }
    },
    "media": {
        "fileDropZone": {
            "text": "Drag & drop or <1>Browse</1>"
        },
        "photoUploadDialog": {
            "btnCancel": "Cancel",
            "btnSave": "Save"
        },
        "fileUploadDialog": {
            "btnCancel": "Cancel",
            "btnSave": "Save"
        }
    },
    "map": {
        "toggleBaseMap": "Toggle Base Layer",
        "mapButtonFitBounds": {
            "centerOn": {
                "features": "Center on features",
                "feature": "Center on feature",
                "layer": "Center on layer",
                "area": "Center on area",
                "areas": "Center on areas",
                "route": "Center on route",
                "visit": "Center on visit",
                "netherlands": "Center on the Netherlands",
                "address": "Center on address"
            },
            "option": {
                "features": "Features",
                "feature": "Feature",
                "layer": "Layer",
                "area": "Area",
                "areas": "Areas",
                "route": "Route",
                "visit": "Visit",
                "netherlands": "The Netherlands",
                "address": "Address"
            },
            "openOptions": "Center options",
            "editAddress": "Edit address",
            "back": "Back",
            "labelAddress": "Address",
            "labelAddressNoOptions": "Enter a street and house number",
            "addressLookupFailed": "Could not find the location of this address",
            "btnCenter": "Center"
        },
        "mapShapeIcon": {
            "Square": "Square",
            "TriangleUp": "Triangle up",
            "TriangleDown": "Triangle down",
            "Circle": "Circle",
            "Pentagon": "Pentagon",
            "Diamond": "Diamond",
            "Hexagon": "Hexagon",
            "Plus": "Plus",
            "StarThree": "Three-point star",
            "StarFour": "Four-point star",
            "StarFive": "Five-point star",
            "StarSix": "Six-point star"
        }
    },
    "mapEditor": {
        "layerType": {
            "Other": "Other",
            "Areas": "Areas",
            "MediaPoints": "Media points",
            "Observations": "Observations",
            "EcologicalFunctions": "Ecological Functions"
        },
        "drawing": {
            "draw": "Draw",
            "drawing": "Drawing..."
        },
        "featureType": {
            "LineString": "Line",
            "Point": "Point",
            "Polygon": "Area"
        },
        "MapEditorFeatureDetails": {
            "noTitle": "Feature",
            "featureDelete": {
                "btnDelete": "Delete feature"
            }
        },
        "mapEditorLayersTree": {
            "title": "Layers",
            "showAll": "Show all",
            "hideAll": "Hide all",
            "btnNewLayer": "New layer"
        },
        "mapEditorLayerCreateDialog": {
            "title": "New data layer",
            "create": "Create",
            "import": "Import"
        },
        "mapEditorLayerImport": {
            "couldNotImport": "Could not import file. Is the format correct?"
        },
        "mapEditorLayerForm": {
            "title": "Add data layer",
            "labelName": "Name",
            "labelProtocol": "Select protocols",
            "btnSave": "Save",
            "btnCancel": "Cancel",
            "labelShowDuringFieldwork": "Show during fieldwork"
        },
        "mapEditorLayerDetails": {
            "btnDelete": "Delete layer",
            "labelName": "Name",
            "labelStyle": "Style",
            "labelProtocols": "Protocols",
            "labelShowDuringFieldwork": "Show during fieldwork",
            "btnSave": "Save",
            "showToClientUser": "Show to client users"
        },
        "mapEditorFeatureCollectionsPane": {
            "importFeatureCollectionFiles": "Import files",
            "plannerAreaFeatureCollection": "Planner Areas",
            "walkingRouteFeatureCollection": "Walking routes",
            "pointsOfInterestFeatureCollection": "Points of interest",
            "layerName": "Layer name",
            "addLayer": "Add layer",
            "noPlannerAreas": "Planner areas not yet configured"
        },
        "mapEditorFeatureCollectionsDetail": {
            "editFeatureCollectionTitle": "Edit layer",
            "saveButton": "Save",
            "updateButton": "Update",
            "deleteButton": "Delete"
        },
        "mapEditorFeatureDetail": {
            "editFeatureTitle": "Edit feature from",
            "updateButton": "Update",
            "deleteButton": "Delete"
        },
        "featureDetailObservation": {
            "title": "Observation",
            "validationStatusAlert": {
                "title": "Not all fields are completed"
            },
            "observationType": "Observation type",
            "observationTypeRequired": "Observation type is required",
            "species": "Species",
            "createdAt": "Created at",
            "media": "Media",
            "preciseLocation": "Precise Location",
            "observationDetails": "Observation Details",
            "btnSave": "Save",
            "btnCancel": "Cancel",
            "btnReject": "Reject",
            "btnRejectSmall": "Reject observation",
            "btnApprove": "Approve",
            "btnDisabledIncomplete": "Complete this observation to change its status",
            "cloneDialogTitle": "Clone observation",
            "cloneDialogDescription": "This creates a copy of the observation with its properties and medias. Ecological function links are not copied.",
            "labelFeedback": "Feedback",
            "labelFeedbackRating": "Feedback",
            "labelFeedbackComment": "Comment"
        },
        "featureDetailEcologicalFunction": {
            "title": "Ecological function",
            "ecologicalFunctionType": "Ecological Function Type",
            "species": "Species",
            "createdAt": "Created At",
            "media": "Media",
            "preciseLocation": "Precise Location",
            "ecologicalFunctionDetails": "Ecological Function Details"
        },
        "featureDetailArea": {
            "title": "Planner area",
            "tabVisitList": "Visits",
            "tabSettings": "Settings"
        },
        "featureDetailAreaSettings": {
            "labelName": "Name",
            "labelStatus": "Status",
            "confirmedStatusLabel": "Confirmed",
            "onHoldStatusLabel": "On hold",
            "cancelledStatusLabel": "Cancelled",
            "labelDescription": "Description",
            "labelDescriptionClient": "Description (Client)",
            "labelDescriptionFieldworker": "Description (Fieldworker)",
            "labelDescriptionInternal": "Description (Internal)",
            "clientSectionTitle": "Client",
            "clientSectionCaption": "This section is visible to Clients only",
            "fieldworkerSectionTitle": "Fieldworker",
            "fieldworkerSectionCaption": "This section is visible to Fieldworkers only",
            "internalSectionTitle": "Internal",
            "internalSectionCaption": "This section is visible to Admins only",
            "btnSave": "Save",
            "media": "Media",
            "protocols": "Protocols",
            "btnAddProtocol": "Add protocol",
            "modal": {
                "title": "Add protocol",
                "labelTitle": "Choose a protocol",
                "btnSubmit": "Add"
            },
            "statusChangeNotAllowed": "Changing to this status is not allowed at this moment"
        },
        "featureDetailMediaPoint": {
            "title": "Media point",
            "createdAt": "Created at",
            "detections": "Detections",
            "btnSave": "Save"
        },
        "featureDetailOther": {
            "title": "Other feature"
        },
        "mapEditorAddressImport": {
            "title": "Import address",
            "imported": "Imported",
            "addresses": "addresses.",
            "errorMessage": "{{numberOfErrors}} addresses could not be imported. You will receive an email with the missing addresses.",
            "outOf": "out of",
            "closestMatch": "Closest match"
        },
        "layerConfigDetails": {
            "labelType": "Type",
            "labelSpecies": "Species"
        },
        "ecologicalFunctionCard": {
            "btnLink": "Link",
            "btnUnlink": "Unlink",
            "labelMedia": "Media"
        },
        "ecologicalFunctionLinking": {
            "dividerTitle": "Add Functions",
            "dividerLinkedFunctions": "Linked Functions",
            "tabCreateNew": "Create new",
            "tabLinkToExisting": "Link to existing",
            "labelFunctionType": "Function type",
            "btnCreate": "Create",
            "noLinkableFunctions": "No Functions available to link",
            "noLinkableFunctionTypes": "No linkable Function Types configured"
        },
        "observationCard": {
            "labelSpecies": "Species",
            "labelObservationType": "Observation type",
            "btnLink": "Link",
            "btnUnlink": "Unlink",
            "labelMedia": "Media",
            "btnShowDetails": "Show details ({{count}})",
            "btnHideDetails": "Hide details ({{count}})"
        },
        "observationLinking": {
            "dividerTitle": "Add Observations",
            "dividerLinkedObservations": "Linked Observations",
            "noLinkableObservations": "No Observations available to link"
        },
        "mapEditorVisitLists": {
            "startTimeText": "Start time: <strong>{{datetime}}</strong>",
            "visitStatus": {
                "unplanned": "Unplanned",
                "draft": "Draft",
                "planned": "Planned",
                "awaitingReport": "Awaiting reports",
                "awaitingApproval": "Awaiting approval",
                "awaitingConfirm": "Awaiting confirmation",
                "awaitingObservationApproval": "Awaiting observation approval",
                "approved": "Approved",
                "rejected": "Rejected"
            },
            "workers": "Number of workers",
            "routeStartDirection": "Route direction",
            "routeStartOffset": "Route start"
        },
        "mapEditorFeatureList": {
            "labelNoFeatures": "No features available.",
            "labelNoTitle": "No Title available",
            "labelFeatureList": "Feature List",
            "labelSettings": "Settings"
        },
        "mapEditorFeatureDetails": {
            "labelProperties": "Properties",
            "labelKey": "Key",
            "labelValue": "Value",
            "labelObservations": "Observations"
        },
        "mapEditorPropertiesGrid": {
            "colKey": "Key",
            "colValue": "Value",
            "addRow": "Add property"
        },
        "mapEditorFeatureCreateDialog": {
            "title": "Create new item",
            "subtitle": "Select an action",
            "btnCancel": "Cancel",
            "btnStartDrawing": "Start Drawing",
            "drawTypeSection": {
                "title": "What do you want to draw?",
                "labelDrawArea": "Draw Area / Route",
                "labelAddObservation": "Add Observation",
                "labelAddFunction": "Add Function",
                "labelDrawOther": "Draw Other"
            },
            "plannerAreaSection": {
                "title": "Drawing Type",
                "labelProtocol": "Protocol"
            },
            "observationSection": {
                "labelSpecies": "Species",
                "labelNoSpecies": "No species available",
                "labelSelectObservationType": "Select observation type"
            },
            "ecologicalFunctionSection": {
                "labelSelectEcologicalFunctionType": "Select ecological function type"
            }
        },
        "mapEditorFeatureCreateOptions": {
            "sectionPlannerArea": "Planner Area",
            "labelArea": "Area",
            "labelRoute": "Route",
            "labelPolygon": "Polygon",
            "labelLine": "Line",
            "labelPoint": "Point",
            "labelSelectProtocols": "Select protocols",
            "sectionObservation": "Observation"
        },
        "mapEditorFeatureCreateButton": {
            "labelDrawSomething": "Draw something",
            "labelDrawObservation": "Draw {{observationType}}",
            "labelDrawPlannerArea": "Draw planner area",
            "labelDrawEcologicalFunction": "Draw {{ecologicalFunctionType}}",
            "labelDrawOtherObject": "Draw other object",
            "btnChange": "Change",
            "ariaLabelChangeDrawOption": "Change draw option"
        },
        "mapEditorFeatureDetailMediaPoint": {
            "labelMediaPoint": "Media point:"
        },
        "speciesGroupTree": {
            "label": "Species"
        },
        "ecologicalFunctionTypeTree": {
            "label": "Functions"
        },
        "observationTypeTree": {
            "label": "Observation types"
        },
        "protocolTree": {
            "label": "Visits",
            "visit": "Visit"
        },
        "featureDetailPlannerAreaVisitList": {
            "confirmDeleteModal": {
                "title": "Delete visit?",
                "alertMessage": "This visit will be soft-deleted. The deletion will be recorded with your name and reason.",
                "reason": "Reason for deletion",
                "btnCancel": "Cancel",
                "btnSubmit": "Delete"
            }
        }
    },
    "fieldworker": {
        "fieldworkerMenu": {
            "header": "Fieldworker",
            "planning": "Calendar",
            "availability": "Availability",
            "shifts": "Shifts",
            "feedback": "Feedback"
        },
        "fieldworkerAvailabilityForm": {
            "labelMaxShiftsPerWeek": "Maximum shifts per week",
            "noCoolOffBetweenShifts": "Allow morning shift after evening shift",
            "btnSave": "Save",
            "notes": "Note: in exceptional cases the times may differ from the above times. In that case you will be contacted in advance."
        },
        "fieldworkerAvailabilityScreen": {
            "availabilityTitle": "Availability",
            "availabilityContent1": "In the overview below, you can specify your general availability. Note: In addition to your availability, you can indicate the maximum number of shifts you want to work per week. Two weeks in advance, your availability will be locked, and you will no longer be able to adjust it.",
            "availabilityContent2": "Most shifts last 2 to 3 hours, excluding travel time. We try to assign you to shifts that are less than an hour’s drive away as much as possible.",
            "availabilityContent3": "Based on your specified availability, we will create a schedule. The schedule is made weekly and depends on various factors (e.g., season and weather). Availability does not guarantee work.",
            "availabilityAttention": "Attention: ",
            "availabilityContent4": "During the season, we require a minimum availability of two shifts per week. Additionally, during the spring bat surveys, you must be available for at least one morning shift per week.",
            "addTimeOff": "Add time off"
        },
        "calendarDay": {
            "saveChanges": "Save changes"
        },
        "calendarTimeOffPlanPopup": {
            "title": "Time Off",
            "titleEdit": "Edit Time Off Request",
            "titleAdd": "Add Time Off Request",
            "labelStartTime": "Start Time",
            "labelEndTime": "End Time",
            "labelReason": "Reason",
            "labelDelete": "Delete",
            "labelEdit": "Save",
            "labelAdd": "Add",
            "btnClose": "Close",
            "errorDescriptionIsRequired": "Description is required"
        },
        "fieldworkerWelcomeMessage": {
            "title": "Welcome {{firstName}}",
            "description": "You have filled in everything to get started as a field worker. Click on the menu at the top left to adjust your availability or to view your calendar. You can request days off directly via the calendar."
        },
        "shifts": {
            "title": "Shifts overview",
            "noShifts": "No shifts to display"
        },
        "shiftItem": {
            "labelDate": "Date",
            "labelType": "Type",
            "labelDistance": "Distance",
            "labelDuration": "Duration",
            "labelNoPayment": "No payment has been made",
            "labelShiftToBeApproved": "Shift yet to be approved for payment",
            "labelShiftToBePaid": "Shift yet to be paid",
            "labelShiftReadyForPayment": "Ready for payment",
            "labelShiftPaid": "Shift paid",
            "labelCarpool": "Carpool",
            "labelMyWheels": "MyWheels"
        },
        "shiftVisits": {
            "btnOpenPlanner": "Open in planner",
            "btnOpenPlannedVisit": "Open in scheduled visits",
            "labelReports": "Reports",
            "labelNoNotes": "No notes"
        },
        "FieldworkerFeedbackListScreen": {
            "title": "Feedback",
            "subtitle": "View your recent feedback here. If you have questions about your feedback, please contact your supervisor.",
            "noFeedbackSubtitle": "You haven't received any feedback yet"
        },
        "FieldworkerFeedbackScreen": {
            "feedback": "Feedback",
            "observations": "Observations with feedback",
            "noObservations": "No observations with feedback",
            "ObservationListItem": {
                "feedback": "Feedback",
                "medias": "Media",
                "echometer": "Echometer"
            },
            "visitConditions": "Weather",
            "titleStartForm": "Start form",
            "titleSubmittedForm": "End form",
            "visitConditionsUnavailable": "Weather unavailable"
        },
        "fieldworkerFeedbackScreen": {
            "title": "Feedback"
        }
    },
    "settings": {
        "settingsListRoute": {
            "title": "Settings"
        },
        "settingsOptionsList": {
            "speciesDatabase": {
                "name": "Species Database",
                "description": "See and edit the full species database"
            },
            "researchTypes": {
                "name": "Research Types",
                "description": "Create research types and modify observation from fields"
            },
            "researchRequirements": {
                "name": "Research Requirements",
                "description": "Define requirements (e.g. equipment lists, training certificates, etc.)"
            },
            "masterForms": {
                "name": "Master Forms",
                "description": "Modify default form fields and app-specific forms"
            },
            "protocolTemplates": {
                "name": "Protocol Templates",
                "description": "View, edit and create new protocol templates"
            }
        }
    },
    "species": {
        "settingsSpeciesListRoute": {
            "title": "Species Database",
            "headerName": "Name",
            "headerScientificName": "Scientific Name",
            "headerDescription": "Description",
            "filterSearch": "Search by name"
        },
        "settingsSpeciesCreateRoute": {
            "title": "New Species"
        },
        "settingsSpeciesEditRoute": {
            "title": "Edit Species",
            "dangerZone": "Danger Zone",
            "speciesDeleteBtn": "Delete Species"
        },
        "speciesForm": {
            "labelName": "Name",
            "labelScientificName": "Scientific Name",
            "labelDescription": "Description",
            "labelIsRareSpecies": "Rare species",
            "labelMapColor": "Map colour",
            "btnSubmit": "Save"
        }
    },
    "researchType": {
        "settingsResearchTypeListRoute": {
            "title": "Research Types",
            "headerName": "Name",
            "headerSpecies": "Species",
            "headerDescription": "Description",
            "filterSearch": "Search by name"
        },
        "settingsResearchTypeCreateRoute": {
            "title": "New Research Type"
        },
        "researchTypeCreateForm": {
            "labelName": "Name",
            "labelDescription": "Description",
            "labelRequireRecordings": "Require recordings",
            "labelSpecies": "Select one or more species",
            "btnSubmit": "Save"
        },
        "settingsResearchTypeEditRoute": {
            "title": "Update Research Type",
            "visitSummaryTemplateTitle": "Visit summary template",
            "dangerZone": "Danger Zone",
            "researchTypeDeleteBtn": "Delete Research Type",
            "researchTypeSpeciesListTitle": "Species",
            "observationTypeListTitle": "Observation Types",
            "btnCreateObservationType": "Create Observation Type",
            "formTemplateEditorTitle": "Submit Form Fields",
            "functionTypeListTitle": "Function Types",
            "btnCreateFunctionType": "Create Function Type"
        },
        "visitSummaryTemplateForm": {
            "labelTemplate": "Template (JSON)",
            "helperText": "Decides which sentences a visit summary gets. Applies to visits approved from now on. Leave empty to remove the template.",
            "errorInvalidJson": "This is not valid JSON.",
            "btnSubmit": "Save"
        },
        "researchTypeUpdateForm": {
            "labelName": "Name",
            "labelDescription": "Description",
            "labelRequireRecordings": "Require recordings",
            "btnSubmit": "Save"
        },
        "researchTypeSpeciesListCard": {
            "actionAddSpecies": "Add Species"
        },
        "researchTypeSpeciesForm": {
            "actionAddSpecies": "Add Species",
            "labelAddSpecies": "Select species",
            "labelShowToClientUser": "Always show to client",
            "btnSubmit": "Save"
        },
        "researchTypeSpeciesDataGrid": {
            "headerName": "Name",
            "headerScientificName": "Scientific Name",
            "headerShowToClientUser": "Show to client",
            "headerDelete": "Delete"
        },
        "observationTypeDataGrid": {
            "headerName": "Name",
            "headerDescription": "Description"
        },
        "functionTypeDataGrid": {
            "headerName": "Name",
            "headerObservationTypes": "Supporting Observations"
        }
    },
    "course": {
        "courseListScreen": {
            "title": "Research Requirements"
        },
        "courseCreateScreen": {
            "title": "New Research Requirement"
        },
        "courseEditScreen": {
            "title": "Edit Research Requirement",
            "dangertitle": "Danger zone"
        },
        "courseDataGrid": {
            "headerName": "Name",
            "headerDescription": "Description",
            "externalReference": "External reference",
            "filterSearch": "Search by name"
        },
        "courseForm": {
            "labelName": "Name",
            "labelDescription": "Description",
            "labelexternalReference": "External reference",
            "btnSubmit": "Save"
        },
        "courseDeleteButton": {
            "btnDelete": "Delete Research Requirement"
        },
        "courseUserProtocol": {
            "type": "Add Research Requirement",
            "btnSubmit": "Save Research Requirement",
            "btnTooltip": "All Research Requirements have been assigned"
        }
    },
    "observationType": {
        "settingsObservationTypeCreateRoute": {
            "title": "New Observation Type"
        },
        "observationTypeCreateForm": {
            "labelName": "Name",
            "labelDescription": "Description",
            "labelFeatureType": "Feature type",
            "labelPoint": "Point",
            "labelLineString": "LineString",
            "labelPolygon": "Polygon",
            "btnSubmit": "Save"
        },
        "settingsObservationTypeEditRoute": {
            "title": "Edit Observation Type",
            "formTemplateEditorTitle": "Form Fields",
            "dangerZone": "Danger Zone",
            "observationTypeDeleteBtn": "Delete Observation Type",
            "observationTypeFunctionTypeListTitle": "Function Types"
        },
        "observationTypeUpdateForm": {
            "labelName": "Name",
            "labelDescription": "Description",
            "labelFeatureType": "Feature type",
            "labelPoint": "Point",
            "labelLineString": "LineString",
            "labelPolygon": "Polygon",
            "requiredFieldsDivider": "Required fields",
            "requiredFieldsInfo": "In addition to the fields you’ll add below, this flow includes a set of default fields that appear in every observation. These fields are shown below and can be specified as required for this specific observation type. This will not allow the completion of an observation without filling in those fields.",
            "labelRequireMedia": "Require media",
            "labelRequirePreciseLocation": "Require precise location",
            "labelShowToClientUser": "Always show to client",
            "btnSubmit": "Save"
        },
        "observationTypeFunctionTypeListCard": {
            "actionAddFunctionType": "Add Function Type"
        },
        "observationTypeFunctionTypeForm": {
            "btnSubmit": "Submit"
        },
        "observationTypeFunctionTypeDataGrid": {
            "headerName": "Name",
            "headerDelete": "Delete"
        },
        "observationTypeFunctionTypeSelectElement": {
            "labelAddFunctionType": "Add Function Type"
        }
    },
    "functionType": {
        "settingsFunctionTypeCreateRoute": {
            "title": "New Function Type"
        },
        "functionTypeForm": {
            "labelName": "Name",
            "labelDescription": "Description",
            "labelFeatureType": "Feature type",
            "labelPoint": "Point",
            "labelLineString": "LineString",
            "labelPolygon": "Polygon",
            "labelIsEssential": "Is essential",
            "labelMapIcon": "Map icon",
            "btnSubmit": "Save"
        },
        "settingsFunctionTypeEditRoute": {
            "title": "Edit Function Type",
            "formTemplateEditorTitle": "Form Fields",
            "dangerZone": "Danger Zone",
            "functionTypeDeleteBtn": "Delete Function Type",
            "functionTypeObservationTypeListTitle": "Observation Types"
        },
        "functionTypeObservationTypeListCard": {
            "actionAddObservationType": "Add Observation Type"
        },
        "functionTypeObservationTypeDataGrid": {
            "headerName": "Name",
            "headerDelete": "Delete"
        },
        "functionTypeObservationTypeForm": {
            "btnSubmit": "Submit"
        },
        "functionTypeObservationTypeSelectElement": {
            "labelAddObservationType": "Add Observation Type"
        }
    },
    "formTemplateEditor": {
        "formTemplateEditor": {
            "btnAddField": "Add Field"
        },
        "formTemplateQuestionForm": {
            "btnDelete": "Delete field",
            "btnCancel": "Cancel",
            "btnSave": "Save",
            "labelType": "Type",
            "labelName": "Name",
            "labelRequired": "Required",
            "labelShowToClientUser": "Always show to client",
            "labelDescription": "Description",
            "labelPlaceholder": "Placeholder",
            "labelDefaultValue": "Default value",
            "labelTags": "Tags",
            "typeText": "Text",
            "typeAmount": "Amount",
            "typeRecording": "Recording",
            "typeSelect": "Select",
            "typeDropdown": "Dropdown",
            "typeDateTime": "Date & Time",
            "labelAmount": "Amount",
            "fieldSettingsDivider": "Field Settings",
            "fieldOptionsDivider": "Field Options",
            "labelMultiline": "Multiline",
            "btnAddOption": "Add option",
            "conditionNone": "None",
            "conditionIsEqual": "Is Equal",
            "conditionOr": "Or",
            "labelCondition": "Condition",
            "labelField": "Field",
            "labelFieldValue": "Value",
            "fieldConditionDivider": "Field Condition",
            "btnAddCondition": "Add condition",
            "chipConditionalDisplay": "Displayed when conditions are met",
            "weatherInfoTagLabel": "Weather Info",
            "precipitationTagLabel": "Precipitation",
            "temperatureTagLabel": "Temperature",
            "windForceTagLabel": "Wind Force",
            "windDirectionTagLabel": "Wind Direction",
            "cloudinessTagLabel": "Cloudiness %",
            "summaryInfoTagLabel": "Summary Info",
            "sizingEstimateMaleTagLabel": "Sizing estimate male",
            "sizingEstimateFemaleTagLabel": "Sizing estimate female",
            "sizingEstimateTagLabel": "Sizing estimate"
        }
    },
    "masterForms": {
        "settingsMasterFormListRoute": {
            "title": "Master Forms"
        },
        "masterFormList": {
            "preciseLocation": {
                "name": "Precise Location",
                "description": "Specify exactly where the animal was observed, including any relevant building or orientation details"
            },
            "startVisit": {
                "name": "Start Visit",
                "description": "Log the visit start time and document weather conditions at the time of arrival"
            }
        },
        "masterFormRoute": {
            "preciseLocationFormTitle": "Precise Location Form",
            "startVisitFormTitle": "Start Visit Form"
        }
    },
    "protocol": {
        "timeslotsRelativeTo": {
            "relativeToSunset": "Sunset",
            "relativeToSunrise": "Sunrise",
            "relativeToMidnight": "Midnight"
        },
        "protocolListScreen": {
            "title": "Protocol templates",
            "clientTitle": "Client Protocol Templates",
            "projectTitle": "Project Protocols"
        },
        "protocolCreateScreen": {
            "title": "New protocol template",
            "projectScopeTitle": "New protocol",
            "templateLabel": "Choose a template"
        },
        "protocolEditScreen": {
            "title": "Edit protocol template",
            "titleNonAdmin": "Protocol template",
            "projectScopeTitle": "Edit Protocol",
            "projectScopeTitleNonAdmin": "Protocol",
            "visitsTitle": "Visit config",
            "dangertitle": "Danger zone",
            "workerRequirementsTitle": "Worker requirements",
            "researchRequirementsTitle": "Research requirements"
        },
        "protocolCourseList": {
            "colName": "Name",
            "colDescription": "Description",
            "colDelete": "Delete"
        },
        "protocolDeleteButton": {
            "projectScopeBtnDelete": "Delete protocol",
            "btnDelete": "Delete protocol template"
        },
        "protocolVisitsEditor": {
            "emptyText": "No visit specification yet",
            "conditionsEditorTitle": "Date settings",
            "pricingEditorTitle": "Pricing settings",
            "weatherEditorTitle": "Weather settings",
            "timeslotEditorTitle": "Time settings",
            "name": "Name",
            "description": "Description",
            "btnAdd": "Add visit",
            "btnDeleteVisit": "Delete visit",
            "btnSave": "Save"
        },
        "visitSummary": {
            "timeslots": "Timeslots",
            "duration": "Duration",
            "costPerHour": "Cost/h",
            "name": "Name",
            "weatherConditions": "Weather conditions",
            "temperature": "Temperature",
            "maxWindForce": "Max. wind force",
            "maxPrecipitation": "Max. precipitation",
            "conditions": "Conditions",
            "copyVisit": "Copy Visit"
        },
        "protocolVisitsPricingEditor": {
            "labelPricePerHour": "Price per hour",
            "labelcalculateTravelCosts": "Calculate travel cost"
        },
        "protocolVisitsWeatherEditor": {
            "labelTemperature": "Temperature",
            "labelMaxWindForce": "Max. wind force",
            "labelMaxPrecipitation": "Max. precipitation",
            "precipitation": {
                "dry": "Dry",
                "mist": "Mist",
                "drizzle": "Drizzle",
                "rain": "Rain",
                "heavyrain": "Heavy Rain",
                "hail": "Hail",
                "snow": "Snow"
            }
        },
        "protocolVisitConditionsEditor": {
            "conditionAnd": "And",
            "conditionOr": "Or",
            "conditionMinDate": "Minimum date",
            "conditionMaxDate": "Maximum date",
            "conditionAfterVisit": "After visit",
            "conditionBeforeVisit": "Before visit",
            "selectConditionType": "Condition type",
            "labelMinDate": "Select date",
            "labelMaxDate": "Select date",
            "selectVisit": "Visit",
            "selectVisitEmpty": "Visit",
            "waitDays": "Wait days",
            "btnAddCondition": "Add condition"
        },
        "protocolVistsTimeslotsEditor": {
            "titleTimeslots": "Timeslots",
            "labelDuration": "Duration",
            "durationSuffix": "hours",
            "durationDescription": "Visit hours only. Travel time is calculated seperately",
            "labelStartRelativeTo": "Start relative",
            "labelStartOffset": "Offset",
            "labelEndRelativeTo": "End relative",
            "labelEndOffset": "Offset",
            "addTimeslot": "Add timeslot",
            "availability": "Availability",
            "availabilityRequired": "Fill in this field"
        },
        "protocolDataGrid": {
            "headerName": "Name",
            "headerStartAt": "Start At",
            "filterSearch": "Search by name"
        },
        "protocolForm": {
            "labelName": "Name",
            "labelResearchType": "Research type",
            "labelDescription": "Description",
            "labelCollectAllMediaPoints": "Collect media points",
            "labelCollectAllMediaPointsCollectAll": "Collect all",
            "labelCollectAllMediaPointsCollectObservationsOnly": "Collect only observation media",
            "labelRequiresRouteShuffling": "Shuffle route start positions",
            "labelRequiresRouteShufflingHelperText": "Changing this setting will not affect existing visits",
            "startAt": "Start at",
            "endAt": "End at",
            "btnSubmit": "Save"
        }
    },
    "shared": {
        "ProjectSelectElement": {
            "selectAll": "Select all"
        },
        "SpeciesSelectElement": {
            "typeToSearchLabel": "Type to search...",
            "noOptionsFoundLabel": "No options found"
        },
        "QuestionAmount": {
            "exactBtn": "exact",
            "estimatedBtn": "estimated"
        },
        "VisitSimplifiedStatusChip": {
            "planned": "Planned",
            "unplanned": "Unplanned",
            "approved": "Approved",
            "ecoTeamReview": "Eco Team Review"
        },
        "PlannerAreaStatusChip": {
            "confirmed": "Confirmed",
            "onHold": "On Hold",
            "cancelled": "Cancelled"
        },
        "IsRejectedAlert": {
            "rejected": {
                "actorOnDate": "Rejected by <avatar></avatar> on {{date}}",
                "reason": "Reason"
            },
            "deleted": {
                "actorOnDate": "Deleted by <avatar></avatar> on {{date}}",
                "reason": "Reason"
            }
        },
        "VisitStatusChip": {
            "unplanned": "Unplanned",
            "planned": "Planned",
            "awaitingReport": "Awaiting reports",
            "awaitingApproval": "Awaiting approval",
            "awaitingConfirm": "Awaiting confirmation",
            "awaitingObservationApproval": "Awaiting observation approval",
            "approved": "Approved",
            "deleted": "Deleted"
        },
        "PlannerShiftCompletionStatusSelect": {
            "label": "Shift status",
            "planned": "Planned",
            "awaitingReport": "Awaiting report",
            "awaitingApproval": "Awaiting approval",
            "approved": "Approved"
        }
    },
    "common": {
        "validation": {
            "valid": "Valid",
            "invalid": "Invalid",
            "checking": "Checking validation status..."
        }
    }
}
